import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ProductPage } from './pages/ProductPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/1-day-pass" replace />} />
          <Route path="/:refId" element={<ProductPage />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
